import { render, staticRenderFns } from "./HeroEdit.vue?vue&type=template&id=4843965c&"
import script from "./HeroEdit.vue?vue&type=script&lang=js&"
export * from "./HeroEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports